import * as Yup from 'yup';
import Translator from '../../core/i18n';

const T = Translator.create();

export function getValidation() {
return Yup.object().shape({
    oldPassword: Yup.string()
        .required(T.t('r_enter_old_password')),
    passwordSecurtiyQuestion: Yup.string()
        .required(T.t('r_field_required'))
        .min(8, T.t('r_atleast_eight_character')),
    passwordSecurtiyQuestionAnswer: Yup.string()
        .required(T.t('r_field_required')),
});
}